<template>
    <div class="rewards-redeem">
        <a-breadcrumb style="margin-bottom: 10px;">
            <a-breadcrumb-item>{{ $t('rewards.rewards') }}</a-breadcrumb-item>
            <a-breadcrumb-item>{{ $t('rewards.redeem') }}</a-breadcrumb-item>
        </a-breadcrumb>
        <div style="margin-bottom: 10px;">
            <a-alert :message="$t('rewards.header_tip')" type="info" />
        </div>
        <a-row v-if="!is_mobile">
            <a-col :span="7"></a-col>
            <a-col :span="8" style="padding-left: 10px;">
                <a-input v-model:value="phone_number" size="large" :placeholder="$t('common.phone_number')" />
            </a-col>
            <a-col :span="2">
                <a-button type="primary" :loading="is_loading" @click="doSearch" size="large" style="margin-left: 10px; width: 100%;">
                    {{ $t('common.search')}}
                </a-button>
            </a-col>
            <a-col :span="7"></a-col>
        </a-row>
        <div v-else>
            <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="20" style="padding-left: 10px;">
                    <a-input v-model:value="phone_number" size="large" :placeholder="$t('common.phone_number')" />
                </a-col>
                <a-col :span="2"></a-col>
            </a-row>
            <a-row style="margin-top: 10px;">
                <a-col :span="2"></a-col>
                <a-col :span="20">
                    <a-button type="primary" :loading="is_loading" @click="doSearch" size="large" style="margin-left: 0px; width: 100%;">
                        {{ $t('common.search')}}
                    </a-button>
                </a-col>
                <a-col :span="2"></a-col>
            </a-row>
        </div>
        <a-flex wrap="wrap" gap="middle" :vertical="is_mobile" style="margin-top: 20px;">
            <div v-for="item in rewards_data" v-bind:key="item.id" :style="{ width: is_mobile ? '100%' : '31%', maxHeight: '350px'}">
                <a-card hoverable :bordered="false">
                    <template #cover v-if="item.marketing_img">
                        <img style="height: 150px;" :src="item.marketing_img" />
                    </template>
                    <a-card-meta :title="item.coupon_name">
                        <template #description>
                            <p>
                                <span>{{ $t('common.name')}}: {{ item.name || '' }}</span><br>
                                <span>{{ $t('common.phone_number')}}: {{ item.phone || '' }}</span><br>
                                <span v-if="item.status == 1" style="color: #1890ff; font-weight: bold;">
                                    {{ $t('rewards.used_time_label')}} : {{ item.use_time && moment.tz(item.use_time * 1, timezone).format('YYYY-MM-DD HH:mm:ss') || '' }}
                                </span>
                            </p>
                        </template>
                    </a-card-meta>
                    <template #actions>
                        <a-button v-if="item.status == 0" @click="doRedeem(item)" type="primary">
                            {{ $t('rewards.redeem')}}
                        </a-button>
                        <a-button v-if="item.status == 1" :disabled="true">
                            {{ $t('rewards.used')}}
                        </a-button>
                    </template>
                </a-card>
            </div>
        </a-flex>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { Modal } from 'ant-design-vue';
    import { createVNode } from 'vue';
    import moment from 'moment-timezone';

    export default {
        name: 'RewardsRedeem',
        components: {
        },
        data() {
            return {
                phone_number: '',
                is_mobile: this.$store.state.app.is_mobile,
                sid: this.$store.state.app.sid,
                timezone: this.$store.state.app.timezone || 'America/New_York',
                screen_width: window.screen.width,
                rewards_data: [],
                is_loading: false,
                moment,
            };
        },
        beforeMount() {
        },
        computed: {},
        methods: {
            ...mapActions({
                getCouponList: 'reward/get_reward_list',
                doRedeemCoupon: 'reward/redeem_reward',
            }),
            async doSearch() {
                if (!this.phone_number) {
                    Modal.error({
                        title: 'Error',
                        content: 'Please input phone number',
                    });
                    return;
                }
                this.is_loading = true;

                let query_data = {
                    sid: this.sid,
                    coupon_id: '',
                    card_number: '',
                    phone_oid: this.phone_number,
                    page: 1,
                    size: 50,
                    sort: 2,
                    active: 2,
                };

                let res = await this.getCouponList(query_data);
                if (res.code == 100000) {
                    this.rewards_data = res.data.list;
                } else {
                    this.rewards_data = [];
                    this.$message.error(res.msg);
                }

                this.is_loading = false;
            },
            doRedeem(item) {
                let that = this;
                Modal.confirm({
                    title: this.$t('rewards.sure_to_redeem') + ` ${item.coupon_name}】？`,
                    content: createVNode('p', { style: 'color: #1890ff; font-weight: bold;' },`${item.name || ''} / ${item.phone || ''}`),
                    okText: this.$t('common.confirm'),
                    cancelText: this.$t('common.cancel'),
                    maskClosable: true,
                    onOk: async() => {
                        let post_data = {
                            token: item.write_off_token,
                            foreign_id: '',
                            business: '',
                            extend: '',
                            use_channel: 1,
                            use_source: 1,
                        };

                        let res = await that.doRedeemCoupon(post_data);

                        if (res.code == 100000) {
                            Modal.success({
                                title: 'Success',
                                content: 'Redeem success',
                            });

                            this.phone_number = '';
                            this.rewards_data = [];
                        } else {
                            Modal.error({
                                title: 'Error',
                                content: res.msg,
                            });
                        }
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                });
            }
        }
    };
</script>

<style scoped>
    .rewards-redeem {
        padding: 10px 20px 50px;
        height: 100%;
        overflow: auto;
    }
    
</style>
